"use client";

import { useContext } from "react";

import { ParentHoverContext } from "../contexts/ParentHoverContext";

/**
 * Hook to access parent hover state from ParentHoverContext
 * @returns The parent hover state or false if no context is provided
 */
export const useParentHover = () => {
  const context = useContext(ParentHoverContext);

  return {
    parentHover: context?.parentHover ?? false,
  };
};
